import {SpaAsyncConfig, SpaGlobalConfig} from '../../../generated/core';
import {Dependency} from '@volkswagen-onehub/inspect-fa-service';
import packageJson from '../../../package.json';
import {externals} from './initInspectFaService';

export function createDependencies(
    config: SpaGlobalConfig,
    asyncConfig: SpaAsyncConfig
) {
    const fsbVersionMatch =
        asyncConfig.featureHubConfiguration.clientBundleUrl.match(
            /-v?([^-]+)\.js$/
        );

    const libs = [
        '@volkswagen-onehub/components-core',
        '@volkswagen-onehub/icons-core'
    ].map(key => {
        const version = (packageJson.dependencies as Record<string, string>)[
            key
        ];
        return {
            id: key,
            version,
            type: 'lib'
        };
    });

    const externalDeps: Dependency[] = Object.entries(packageJson.dependencies)
        .filter(([key]) => externals.includes(key))
        .map(([key, value]) => ({
            id: key,
            version: value,
            type: 'external'
        }));
    const dependencies: Dependency[] = [
        ...libs,
        ...externalDeps,
        {
            id: 'feature-service-bundle',
            version:
                fsbVersionMatch && fsbVersionMatch.length > 1
                    ? fsbVersionMatch[1]
                    : '',
            type: 'integrator'
        },
        {
            id: 'cms',
            version: config.cmsVersion,
            type: 'integrator'
        }
    ];
    if (asyncConfig.featureHubConfiguration.marketClientBundleUrl) {
        dependencies.push({
            id: 'market-feature-service-bundle',
            version: '',
            type: 'integrator'
        });
    }
    return dependencies;
}
